import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {withSafeArea} from '/provider/SafeAreaProvider';
import {
  hasSearchInput,
  hasSearchResultsBySearchInput,
  isLoadingBySearchInput,
  searchResultsBySearchInput,
} from '/redux/selector/search.selector';
import {withHOC} from '/util/hoc.util';

import {SearchResultsRenderer} from './SearchResultsRenderer';

export const SearchResultsRendererConnected = withHOC(
  connect(
    createStructuredSelector({
      hasSearchResults: hasSearchResultsBySearchInput,
      isLoading: isLoadingBySearchInput,
      searchResults: searchResultsBySearchInput,
      hasSearchInput,
    }),
  ),
  withSafeArea,
)(SearchResultsRenderer);
